import { render } from "./distributeDialog.vue?vue&type=template&id=476f6312&scoped=true"
import script from "./distributeDialog.vue?vue&type=script&lang=js"
export * from "./distributeDialog.vue?vue&type=script&lang=js"

import "./distributeDialog.vue?vue&type=style&index=0&id=476f6312&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476f6312"]])

export default __exports__